import { cn } from "@/lib/utils";
import { IMaskInput } from "react-imask";
import type { KeyboardEvent } from "react";

export const maskedDateInputClassName = cn(
  "file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground",
  "border-input flex h-9 w-full min-w-0 flex-1 rounded-none border-0 bg-transparent px-3 py-1 text-base shadow-none outline-none",
  "transition-[color,box-shadow] file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium",
  "disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
  "focus-visible:ring-0 dark:bg-transparent",
  "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive"
);

interface MaskedDateInputProps {
  mask: string;
  value: string;
  placeholder: string;
  disabled?: boolean;
  invalid?: boolean;
  ariaDescribedBy?: string;
  onAccept: (_value: string) => void;
  onFocus: () => void;
  onBlur: () => void;
  onKeyDown: (_event: KeyboardEvent<HTMLInputElement>) => void;
}

export function MaskedDateInput({
  mask,
  value,
  placeholder,
  disabled,
  invalid,
  ariaDescribedBy,
  onAccept,
  onFocus,
  onBlur,
  onKeyDown,
}: MaskedDateInputProps) {
  return (
    <IMaskInput
      mask={mask}
      lazy
      unmask={false}
      value={value}
      placeholder={placeholder}
      disabled={disabled}
      aria-invalid={invalid}
      aria-describedby={ariaDescribedBy}
      data-slot="input-group-control"
      className={maskedDateInputClassName}
      onAccept={onAccept}
      onFocus={onFocus}
      onBlur={onBlur}
      onKeyDown={onKeyDown}
    />
  );
}
